(() => {
  angular
    .module('gm.common.directives')
    .directive('gmCheckboxToggle', gmCheckboxToggleDirective);

  function gmCheckboxToggleDirective() {
    'ngInject';

    const has = Object.prototype.hasOwnProperty;
    let indexVal = 1;

    return {
      restrict: 'E',
      require: 'ngModel',
      transclude: true,
      replace: true,
      scope: {
        ngModel: '=',
        trueLabel: '@?',
        falseLabel: '@?'
      },
      templateUrl: 'modules/common/directives/forms/checkbox-toggle/checkbox-toggle.html',

      link(scope, _element, attrs, ctrl, transclude) {
        const trueValue = has.call(attrs, 'ngTrueValue') ? attrs.ngTrueValue : true;
        const falseValue = has.call(attrs, 'ngFalseValue') ? attrs.ngFalseValue : false;

        scope.noColor = has.call(attrs, 'noColor');

        scope.state = false;
        indexVal += 1;
        scope.uniqueIndex = indexVal;

        scope.$watch(() => ctrl.$viewValue, (newState) => {
          scope.state = (newState === trueValue);
        });

        scope.$watch('state', (state) => {
          ctrl.$setViewValue(state ? trueValue : falseValue);

          if (has.call(attrs, 'required')) {
            ctrl.$setValidity('required', !!state);
          }
        });

        scope.toggleCheckbox = function _toggleCheckbox(event) {
          event.preventDefault();

          scope.state = !scope.state;
        };

        transclude((content) => {
          if (content.length) {
            scope.hasTranscludeContent = true;
          }
        });
      }
    };
  }
})();
